import { ExportFormat, ExportFormatType } from '../../domain/ExportFormat.const';

// Endpoints de wuzi-portal-bff (relativos a REACT_APP_API_URL + '/bff', ver src/services/api.ts).
// El BFF resuelve el usuario por el email del token: el front nunca envía customerId/merchantId.
export const SETTLEMENTS_ENDPOINTS = {
  summary: '/settlements-view/summary',
  report: '/settlements-view/summary/report',
} as const;

// La consulta de liquidaciones tarda ~20 s en el backend: supera el timeout global de api.ts (15 s).
export const SETTLEMENTS_REQUEST_TIMEOUT_MS = 60000;

export const SETTLEMENTS_REPORT_FILE_NAME = 'Reporte-liquidaciones';
// El backend genera el reporte corporativo de liquidaciones solo en Excel.
export const SETTLEMENTS_REPORT_FORMATS: ExportFormatType[] = [ExportFormat.XLSX];
export const SETTLEMENTS_REPORT_LABEL = 'Descargar Excel';
export const SETTLEMENTS_PAGE_SIZE = 10;
export const API_DATE_PATTERN = 'yyyy-MM-dd';
export const DISPLAY_DATE_PATTERN = 'dd/MM/yyyy';
